import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import { createContext, createElement, useReducer, useEffect, useContext } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import * as stylesheets$1 from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Prism } from 'react-syntax-highlighter';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var context = {
  rows: [],
  columnCount: 3,
  theme: 'coy'
};
var CheatsheetContext = createContext(context);

function filterBadSnippets(snippets) {
  return snippets.filter(function (o) {
    if (!o.id && !o.title && !o.snippet) {
      console.warn('Found an invalid snippet. It was not included in the cheat sheet');
      return false;
    }

    return true;
  });
}

function formatSnippets(snippets, columnCount) {
  var reducer = function reducer(acc, snippet) {
    var lastColumn = last(acc); // Maximum items of each row is the value of columnCount

    if (lastColumn.length < columnCount) {
      lastColumn.push(snippet);
    } else {
      // Instantiate a new row when current row has reached its max
      acc.push([snippet]);
    }

    return acc;
  };

  var result = snippets.reduce(reducer, [[]]);
  return result;
}

function getRowStyle(isDraggingOver) // { index }: { index?: number } = {},
{
  return {
    display: 'flex',
    // alignItems: 'flex-start',
    outline: 'none',
    background: isDraggingOver ? 'teal' : undefined
  };
}

function getSnippetStyle(isDragging, draggableStyle) {
  return _objectSpread2({
    padding: 8,
    margin: 3,
    flexGrow: 1,
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    userSelect: 'none',
    fontSize: '0.85rem',
    boxShadow: '3px 6px 14px rgba(0, 0, 0, 0.05)',
    border: '1px solid rgba(40, 60, 190, 0.17)',
    background: isDragging ? '#D0FFE0' : undefined
  }, draggableStyle);
}

function getRowIndex(droppableId) {
  return Number(droppableId) - 1;
} // Retrieves the last item in an array


function last(arr) {
  var length = arr ? arr.length : 0;
  return length ? arr[length - 1] : undefined;
}

function reorder(row, start, end) {
  var result = row.slice();

  var _result$splice = result.splice(start, 1),
      _result$splice2 = _slicedToArray(_result$splice, 1),
      removed = _result$splice2[0];

  result.splice(end, 0, removed);
  return result;
}

var stylesheets = ['coy', 'dark', 'funky', 'okaidia', 'solarizedlight', 'tomorrow', 'twilight', 'prism', 'atomDark', 'base16AteliersulphurpoolLight', 'cb', 'darcula', 'duotoneDark', 'duotoneEarth', 'duotoneForest', 'duotoneLight', 'duotoneSea', 'duotoneSpace', 'ghcolors', 'hopscotch', 'pojoaque', 'vs', 'xonokai']; // Moves an item to a separate column

function moveToColumn(source, destination, droppableSource, droppableDestination) {
  var sourceClone = source.slice();
  var destClone = destination.slice();

  var _sourceClone$splice = sourceClone.splice(droppableSource.index, 1),
      _sourceClone$splice2 = _slicedToArray(_sourceClone$splice, 1),
      removed = _sourceClone$splice2[0];

  destClone.splice(droppableDestination.index, 0, removed);
  var result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;
  return result;
}

function trim(str) {
  if (typeof str === 'string') return str.trim();
  return str;
}

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'set-column-count':
      return _objectSpread2({}, state, {
        columnCount: action.columnCount
      });

    case 'set-rows':
      return _objectSpread2({}, state, {
        rows: action.rows
      });

    case 'set-theme':
      return _objectSpread2({}, state, {
        theme: action.theme || context.theme
      });

    default:
      return state;
  }
};

function initSnippets(snippets, columnCount) {
  var args = Array.prototype.slice.call(arguments);

  if (!args.length) {
    throw new Error('"snippets" is required');
  } else if (snippets == null) {
    throw new Error('"snippets" is null or undefined');
  } else if (!Array.isArray(snippets)) {
    throw new Error('"snippets" is not an array');
  }

  var filtered = filterBadSnippets(snippets);
  return formatSnippets(filtered, columnCount);
}

var useCheatsheet = function useCheatsheet(_ref) {
  var snippets = _ref.snippets,
      _ref$columnCount = _ref.columnCount,
      columnCount = _ref$columnCount === void 0 ? context.columnCount : _ref$columnCount,
      themeProp = _ref.theme,
      onThemeChangeProp = _ref.onThemeChange,
      onDragEndProp = _ref.onDragEnd;

  var _React$useReducer = useReducer(reducer, _objectSpread2({}, context, {
    rows: initSnippets(snippets, columnCount),
    theme: themeProp || context.theme,
    columnCount: columnCount
  })),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1]; // We made the droppableId always start at 1 instead of 0


  function getRowSnippets(droppableId, index) {
    index = typeof index === 'number' ? index : getRowIndex(droppableId);
    return state.rows[index];
  }

  function onDragEnd(result) {
    var source = result.source,
        destination = result.destination;

    if (!destination) {
      return;
    }

    var isSameRow = source.droppableId === destination.droppableId;
    var nextRows = state.rows.slice();

    if (isSameRow) {
      var rowIndex = getRowIndex(source.droppableId);
      var nextRowItems = reorder(getRowSnippets(source.droppableId), source.index, destination.index);
      nextRows[rowIndex] = nextRowItems;
      dispatch({
        type: 'set-rows',
        rows: nextRows
      });
    } // Item is being dragged to a separate column
    else {
        var _result = moveToColumn(getRowSnippets(source.droppableId), getRowSnippets(destination.droppableId), source, destination);

        var rowIndexFrom = getRowIndex(source.droppableId);
        var rowIndexTo = getRowIndex(destination.droppableId);
        nextRows[rowIndexFrom] = _result[source.droppableId];
        nextRows[rowIndexTo] = _result[destination.droppableId];
        dispatch({
          type: 'set-rows',
          rows: nextRows
        });
      }

    if (typeof onDragEndProp === 'function') {
      onDragEndProp(nextRows);
    }
  }

  useEffect(function () {
    // Update the state if props.columnCount changed
    if (columnCount !== state.columnCount) {
      dispatch({
        type: 'set-column-count',
        columnCount: columnCount
      });
    }
  }, [state.columnCount, columnCount]);
  useEffect(function () {
    // is controlled
    if (themeProp) {
      if (state.theme !== themeProp) {
        dispatch({
          type: 'set-theme',
          theme: themeProp
        });
      }
    }
  }, [onThemeChangeProp, state.theme, themeProp]);
  return _objectSpread2({}, state, {
    onDragEnd: onDragEnd,
    stylesheets: stylesheets
  });
};

var CheatsheetContextProvider = function CheatsheetContextProvider(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return createElement(CheatsheetContext.Provider, {
    value: useCheatsheet(props)
  }, children);
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_rcsRoot__2-Hvv {\r\n}\r\n\r\n.styles_snippetTitle__3CSCd {\r\n  padding: 10px 6px 0 !important;\r\n  text-transform: none !important;\r\n  margin: 0 !important;\r\n  font-weight: 300 !important;\r\n  color: rgba(150, 150, 150, 0.95) !important;\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.styles_snippetAction__14zhY {\r\n}\r\n\r\n.styles_copyIcon__1E4-p {\r\n  cursor: pointer;\r\n  width: 20px;\r\n  height: 20px;\r\n  transition: all 0.5s ease-out;\r\n}\r\n\r\n.styles_copyIcon__1E4-p:hover {\r\n  transform: scale(1.02) translate(3px, -3px);\r\n  color: #000;\r\n}\r\n";
var styles = {
  "rcsRoot": "styles_rcsRoot__2-Hvv",
  "snippetTitle": "styles_snippetTitle__3CSCd",
  "snippetAction": "styles_snippetAction__14zhY",
  "copyIcon": "styles_copyIcon__1E4-p"
};
styleInject(css);

var SnippetContent = function SnippetContent(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      language = _ref.language;
  return createElement("div", null, createElement(Prism, {
    language: language,
    style: stylesheets$1[theme],
    codeTagProps: {},
    customStyle: {
      fontSize: '0.8rem',
      lineHeight: 0.95,
      padding: 4
    }
  }, children));
};

var Snippet = function Snippet(_ref2) {
  var _ref2$language = _ref2.language,
      language = _ref2$language === void 0 ? 'jsx' : _ref2$language,
      theme = _ref2.theme,
      title = _ref2.title,
      snippet = _ref2.snippet,
      index = _ref2.index,
      popup = _ref2.popup,
      innerRef = _ref2.innerRef,
      draggableProps = _ref2.draggableProps,
      dragHandleProps = _ref2.dragHandleProps,
      isDragging = _ref2.isDragging,
      getSnippetStyle = _ref2.getSnippetStyle,
      renderHeader = _ref2.renderHeader,
      renderSnippet = _ref2.renderSnippet,
      renderActions = _ref2.renderActions;
  return createElement("span", _extends({
    ref: innerRef
  }, draggableProps, {
    style: getSnippetStyle(isDragging, draggableProps.style, {
      index: index
    })
  }, dragHandleProps), renderHeader ? renderHeader({
    title: title,
    isDragging: isDragging,
    index: index
  }) : createElement("span", {
    className: styles.snippetTitle
  }, createElement("div", null, title), renderActions && renderActions({
    snippet: snippet,
    index: index,
    isDragging: isDragging
  })), createElement(SnippetContent, {
    language: language,
    theme: theme
  }, renderSnippet ? renderSnippet({
    snippet: snippet,
    popup: popup,
    index: index,
    isDragging: isDragging
  }) : trim(snippet)));
};

var ReactCheatsheet = function ReactCheatsheet(_ref) {
  var language = _ref.language,
      getRowStyleProp = _ref.getRowStyle,
      getSnippetStyleProp = _ref.getSnippetStyle,
      renderHeader = _ref.renderHeader,
      renderSnippet = _ref.renderSnippet,
      renderActions = _ref.renderActions,
      props = _objectWithoutProperties(_ref, ["language", "getRowStyle", "getSnippetStyle", "renderHeader", "renderSnippet", "renderActions"]);

  var ctx = useContext(CheatsheetContext);
  var rows = ctx.rows,
      theme = ctx.theme,
      onDragEnd = ctx.onDragEnd;
  return createElement("div", {
    className: styles.rcsRoot
  }, createElement(DragDropContext, _extends({
    onDragEnd: onDragEnd
  }, props), Array.isArray(rows) && rows.map(function (row, rowIndex) {
    return createElement(Droppable, {
      key: "row".concat(rowIndex),
      droppableId: String(rowIndex + 1),
      direction: "horizontal"
    }, function (_ref2, _ref3) {
      var innerRef = _ref2.innerRef,
          droppableProps = _ref2.droppableProps,
          placeholder = _ref2.placeholder;
      var isDraggingOver = _ref3.isDraggingOver;
      return createElement("div", _extends({}, droppableProps, {
        ref: innerRef,
        style: getRowStyleProp ? getRowStyleProp(isDraggingOver, {
          index: rowIndex
        }) : getRowStyle(isDraggingOver)
      }), row.map(function (props, snippIndex) {
        var draggableId = "snippet_".concat(rowIndex).concat(snippIndex);
        return createElement(Draggable, {
          key: draggableId,
          draggableId: draggableId,
          index: snippIndex
        }, function (provided, snapshot) {
          return createElement(Snippet, _extends({
            language: language,
            theme: theme,
            index: snippIndex,
            draggableId: draggableId,
            innerRef: provided.innerRef,
            draggableProps: provided.draggableProps,
            dragHandleProps: provided.dragHandleProps,
            isDragging: snapshot.isDragging,
            getSnippetStyle: getSnippetStyleProp || getSnippetStyle,
            renderHeader: renderHeader,
            renderSnippet: renderSnippet,
            renderActions: renderActions
          }, props));
        });
      }), placeholder);
    });
  })));
};

var ReactCheatsheets = function ReactCheatsheets(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return createElement(CheatsheetContextProvider, props, createElement(ReactCheatsheet, null));
};

export default ReactCheatsheets;